import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useStore } from './store';
import { onConnectionChange, syncToServer } from './db/offline';
import LoginScreen from './screens/LoginScreen';
import Sidebar from './components/Sidebar';
import {
  SchoolDashboard, StudentsScreen, AttendanceScreen,
  FeesScreen, ExamsScreen, ReportCardsScreen,
  HospitalDashboard, PatientsScreen, DoctorsScreen,
  POSSellScreen, ComingSoon
} from './screens/AllScreens';

const Protected = ({ children }) => {
  const token = useStore(s => s.token);
  return token ? children : <Navigate to="/login" />;
};

function AppLayout() {
  const { module, activeScreen, setOnline, setPendingSync } = useStore();

  useEffect(() => {
    // Monitor online/offline
    onConnectionChange(async (online) => {
      setOnline(online);
      if (online) {
        // Auto-sync when back online
        const result = await syncToServer('http://148.135.136.220').catch(() => ({synced:0,pending:0}));
        if (result.synced > 0) {
          const toast = (await import('react-hot-toast')).default;
          toast.success(`Synced ${result.synced} records`);
        }
        setPendingSync(result.pending);
      }
    });
  }, []);

  const renderScreen = () => {
    // School screens
    if (module === 'school') {
      switch(activeScreen) {
        case 'dashboard':    return <SchoolDashboard />;
        case 'students':     return <StudentsScreen />;
        case 'attendance':   return <AttendanceScreen />;
        case 'fees':         return <FeesScreen />;
        case 'exams':        return <ExamsScreen />;
        case 'reportcards':  return <ReportCardsScreen />;
        case 'staff':        return <ComingSoon title="Staff Management" />;
        case 'certificates': return <ComingSoon title="Certificates" />;
        case 'library':      return <ComingSoon title="Library" />;
        default:             return <SchoolDashboard />;
      }
    }

    // Hospital screens
    if (module === 'hospital') {
      switch(activeScreen) {
        case 'dashboard':     return <HospitalDashboard />;
        case 'patients':      return <PatientsScreen />;
        case 'doctors':       return <DoctorsScreen />;
        case 'appointments':  return <ComingSoon title="Appointments" />;
        case 'prescriptions': return <ComingSoon title="Prescriptions" />;
        case 'lab':           return <ComingSoon title="Lab Tests" />;
        case 'pharmacy':      return <ComingSoon title="Pharmacy" />;
        case 'billing':       return <ComingSoon title="Billing" />;
        default:              return <HospitalDashboard />;
      }
    }

    // POS screens
    if (module === 'pos') {
      switch(activeScreen) {
        case 'sell':       return <POSSellScreen />;
        case 'dashboard':  return <POSSellScreen />;
        case 'products':   return <ComingSoon title="Product Management" />;
        case 'orders':     return <ComingSoon title="Orders" />;
        case 'inventory':  return <ComingSoon title="Inventory" />;
        case 'reports':    return <ComingSoon title="Sales Reports" />;
        default:           return <POSSellScreen />;
      }
    }

    // Other modules
    return <ComingSoon title={`${module.toUpperCase()} ERP`} />;
  };

  return (
    <div style={{ display: 'flex', height: '100vh', background: '#0a0a12', overflow: 'hidden' }}>
      <Sidebar />
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {renderScreen()}
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{
        style: { background: '#1a1a2e', color: '#fff', border: '1px solid #333' }
      }} />
      <Routes>
        <Route path="/"      element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/app"   element={<Protected><AppLayout /></Protected>} />
        <Route path="*"      element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
